// extracted by mini-css-extract-plugin
export var centerText = "_ce-8";
export var container = "_ce-0";
export var doughnutContainer = "_ce-7";
export var legend = "_ce-a";
export var legendItemColorDisplay = "_ce-b";
export var legendItemLabel = "_ce-d";
export var legendItemValue = "_ce-c";
export var lg = "_ce-5";
export var maxWidth = "_ce-9";
export var md = "_ce-4";
export var responsive = "_ce-6";
export var sm = "_ce-3";
export var xs = "_ce-2";
export var xxs = "_ce-1";